import { render, staticRenderFns } from "./BenefitsDescription.vue?vue&type=template&id=1b63c931"
import script from "./BenefitsDescription.vue?vue&type=script&lang=js"
export * from "./BenefitsDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports